import icon from "../../assets/layers.svg";
import type { Property } from "../../types";

export const switchTechnology: Property = {
  id: "switchTechnology",
  title: "switchTechnology.title",
  icon,
};
